<template>
  <div>
     <List v-if="activeName == 'list'"></List>
     <Setting v-if="activeName == 'setting'"></Setting>
  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import List from './lists/index.vue';
import Setting from './setting/index.vue';
export default {
  components: {
    List,
    Setting
  },
  data() {
    return {
      /*当前选中*/
      activeName: 'list',
      sourceList:[
        {
          key: 'list',
          value: '物流中心',
          path:'/plus/logistics/lists/index'
        },
        {
          key: 'setting',
          value: '基础设置',
          path:'/plus/logistics/setting/index'
        },
      ],
      tabList:[]
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {

    this.init();

  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'list',list: [] });
    bus.$off('activeValue');
  },
  methods: {
    /*初始化方法*/
    init(){
      this.tabList=this.sourceList;
      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        if (this.is_third_param) {
          this.param.user_id = '';
          this.is_third_param = false;
        }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'list'
      };
      bus.$emit('tabData', params);
    },
    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/logistics/index.vue